import React, { FC } from "react";
import { PublicContentArea, PublicWrapper } from "../publicComponents";
import logo from ".././../weldingApp_logo_white.svg";
import { Section } from "venice-ui";
import { LoginTile, WelcomeLogo } from "./Login.styles";
import { ResetPasswordForm } from "./ResetPasswordForm";

export const ResetPassword: FC = () => {
 
  return (
    <PublicWrapper>
      <PublicContentArea>
        <WelcomeLogo src={logo} />
        <LoginTile>
          <Section>
          <ResetPasswordForm/>
          </Section>
        </LoginTile>
      </PublicContentArea>
    </PublicWrapper>
  );
};

